import "./Team.css";

const team = [
  {
    id: 1,
    name: "Sachin Pote",
    position: "Founder & Full Stack Developer",
    image: "/images/team/team1.jpg",
    facebook: "#",
    linkedin: "#",
    github: "#"
  },
  {
    id: 2,
    name: "UI/UX Designer",
    position: "Creative Designer",
    image: "/images/team/team2.jpg",
    facebook: "#",
    linkedin: "#",
    github: "#"
  },
  {
    id: 3,
    name: "Frontend Developer",
    position: "React Developer",
    image: "/images/team/team3.jpg",
    facebook: "#",
    linkedin: "#",
    github: "#"
  },
  {
    id: 4,
    name: "Backend Developer",
    position: "PHP & Laravel",
    image: "/images/team/team4.jpg",
    facebook: "#",
    linkedin: "#",
    github: "#"
  }
];

export default function Team() {
  return (
    <section className="team section" id="team">

      <div className="container">

        <div className="section-heading">

          <span>OUR TEAM</span>

          <h2>Meet Our Experts</h2>

          <p>
            Our experienced team delivers innovative digital solutions with
            passion, creativity and modern technologies.
          </p>

        </div>

        <div className="team-grid">

          {team.map((member) => (

            <div className="team-card" key={member.id}>

              <div className="team-image">

                <img src={member.image} alt={member.name} />

                <div className="social">

                  <a href={member.facebook}>
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>

                  <a href={member.linkedin}>
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>

                  <a href={member.github}>
                    <i className="fa-brands fa-github"></i>
                  </a>

                </div>

              </div>

              <div className="team-content">

                <h3>{member.name}</h3>

                <span>{member.position}</span>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}